import React, { useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { PageHeader, Button, Card, Row, Col } from "antd";
import { reverse } from "named-urls";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { userViewSaga } from "./saga";
import * as selectors from "./selectors";
import { addressToStringMultiLine } from "../../../../utils/formatter";
import routes from "../../../../../routes";

const AddressCard = ({ title, address }) => {
  return (
    <Card title={title} style={{ width: 300, marginBottom: 30 }}>
      <div style={{ minHeight: 120 }}>{addressToStringMultiLine(address)}</div>
    </Card>
  );
};

const UserView = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: userViewSaga });
  const dispatch = useDispatch();
  const { companyId, userId } = useParams();
  const history = useHistory();

  useEffect(() => {
    dispatch(actions.fetchUserDetails({ id: userId }));
  }, [dispatch, userId]);

  const user = useSelector(selectors.selectUserDetails) || {};

  const handleBack = () => {
    history.goBack();
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        ghost={false}
        title="User Details"
        onBack={handleBack}
        subTitle={`${user.firstName} ${user.lastName || ""}`}
        extra={[
          <Button key="1" type="primary">
            <Link
              to={reverse(`${routes.backOffice.companies.details.users.edit}`, {
                companyId,
                userId,
              })}
            >
              Edit
            </Link>
          </Button>,
        ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        <div style={{ backgroundColor: "#fff", padding: 20, marginBottom: 30 }}>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1 }}>
              <p>
                <strong>Full Name:</strong> {user.firstName} {user.lastName}
              </p>
              <p>
                <strong>Email: </strong>
                {user.email}
              </p>
              <p>
                <strong>Phone:</strong> {user.phone}
              </p>
              <p>
                <strong>Alternate Phone: </strong>
                {user.alternateContact || "NA"}
              </p>
            </div>
            <div style={{ flex: 1 }}>
              <p>
                <strong>Department:</strong> {user.department}
              </p>
              <p>
                <strong>Designation:</strong> {user.designation}
              </p>
              <p>
                <strong>Company:</strong> {user?.company?.companyName}
              </p>
              <p>
                <strong>Role:</strong>{" "}
                {user?.role === "company_admin"
                  ? "Company Admin"
                  : "Company User"}
              </p>
            </div>
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <h1>Addresses Available</h1>
          <Row gutter={32}>
            {user?.pickupAddress?.map((address) => (
              <Col>
                <AddressCard title="Pickup Address" address={address} />
              </Col>
            ))}
            {user?.billingAddress?.map((address) => (
              <Col>
                <AddressCard title="Billing Address" address={address} />
              </Col>
            ))}
          </Row>
          {user?.pickupAddress?.length === 0 &&
          user?.billingAddress?.length === 0 ? (
            <p>Looks like user doesn't have any address associated with them</p>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default UserView;
